import { GetterTree } from 'vuex';
import { IFieldState } from './field.types';
import { EFieldGetter } from './field.constants';
import { EFieldType } from '@/dealroom/fields/types/enums/field-type';
import { EFieldSource } from '@/dealroom/fields/types/enums/field-source';
import { RootState } from '@/store/store';
import { IField } from '@/dealroom/fields/types/field';
import { calculateFieldPositionForPlacement } from '@/dealroom/fields/helpers/field-placement.helper';

export const getters: GetterTree<IFieldState, RootState> = {
  [EFieldGetter.SelectedFields](state: IFieldState): IField[] {
    return state.fields
      .filter((field: IField) => state.selectedPageFieldIds.fieldIds.includes(field.id))
      .map((field: IField) => ({
        ...field,
        position: calculateFieldPositionForPlacement(field.position, state.pageWidth),
      }));
  },
  [EFieldGetter.FieldsToFillOut](state: IFieldState): IField[] {
    if (!state.fields.length) {
      return [];
    }
    return state.fields.filter(
      (field: IField) =>
        [EFieldType.Dropdown, EFieldType.Text, EFieldType.Formatted, EFieldType.Check].includes(
          field.type
        ) && field.source === EFieldSource.Sender
    );
  },
  [EFieldGetter.LastUpdatedField](state: IFieldState): IField {
    if (!state.fields || !state.fields.length || !state.lastUpdatedFieldId) {
      return null;
    }
    return state.fields.find((field: IField) => field.id === state.lastUpdatedFieldId);
  },
};
